const YOUTUBE_IFRAME_API_ID = "youtube-iframe-api";

export const loadYouTubeIframeAPI = () => {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("YouTube iframe API is unavailable"));
  }
  if (window.YT && window.YT.Player) {
    return Promise.resolve(window.YT);
  }
  if (window.__youtubeIframeApiPromise) {
    return window.__youtubeIframeApiPromise;
  }

  window.__youtubeIframeApiPromise = new Promise((resolve) => {
    const previousCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof previousCallback === "function") {
        previousCallback();
      }
      resolve(window.YT);
    };
    if (!document.getElementById(YOUTUBE_IFRAME_API_ID)) {
      const script = document.createElement("script");
      script.id = YOUTUBE_IFRAME_API_ID;
      script.src = "https://www.youtube.com/iframe_api";
      script.async = true;
      document.body.appendChild(script);
    }
  });

  return window.__youtubeIframeApiPromise;
};
